<template lang="pug">
    el-dropdown(
        class="wam-select"
        :class="{ disabled }"
        @command="handleChange"
        trigger="click"
        size="mini")
        button.wam-select__button(:class="buttonClass" :disabled="disabled" v-html="getValueName")
        el-dropdown-menu.wam-select__dropdown(slot="dropdown")
            .wam-select__label(v-if="label")
                svg-icon(v-if="icon" :name="icon" size="small")
                | {{ label }}
            el-dropdown-item(
                v-for="(option) in options"
                :class="{ 'selected': value == getOptionKey(option) }"
                :command="getOptionKey(option)"
                :key="getOptionKey(option)") {{ getOptionName(option) }}
</template>

<script>
import wamSelectMixin from './mixin'

export default {
    name: 'WamSelect',

    mixins: [wamSelectMixin],

    props: {
        options: {
            type: Array,
            default: () => []
        },
        optionName: {
            type: String,
            default: ''
        },
        optionKey: {
            type: String,
            default: ''
        }
    },

    methods: {
        getOptionKey(option) {
            if (this.optionKey) return option[this.optionKey]
            return option
        },

        getOptionName(option) {
            if (this.optionName) return option[this.optionName]
            return option
        }
    }
}
</script>
